import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=2a5e5612&scoped=true&"
import script from "./Forget.vue?vue&type=script&lang=js&"
export * from "./Forget.vue?vue&type=script&lang=js&"
import style0 from "./Forget.vue?vue&type=style&index=0&id=2a5e5612&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5e5612",
  null
  
)

export default component.exports